import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { StatusCliente } from "../../model/status.model";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { StatusConfigService } from "../../services/status-config.service";
import { ToastService } from "src/app/shared/toasts/toast-service";

@Component({
  selector: "app-status-config-form",
  templateUrl: "./status-config-form.component.html",
  styleUrl: "./status-config-form.component.scss",
})
export class StatusConfigFormComponent implements OnInit {
  @Input() status: StatusCliente | null = null;
  statusForm!: FormGroup;
  loading = false;
  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private statusConfigService: StatusConfigService,
    private toastService: ToastService,
  ) {}

  ngOnInit(): void {
    this.statusForm = this.fb.group({
      id: [this.status?.id],
      nome: [this.status?.nome ? this.status.nome.split('|')[0] : '', Validators.required],
      cor: ['bg-light-subtle', Validators.required],
    });
  }

  onSubmit(): void {
    if (this.statusForm.invalid) {
      return;
    }
    this.loading = true;
    if (this.status) {
      this.statusConfigService
        .editStatusMessage(this.status.id, this.statusForm.value)
        .subscribe({
          next: () => {
            this.toastService.show("Status atualizado com sucesso", {
              classname: "bg-success text-light",
            });
            this.activeModal.close();
          },
          error: () => {
            this.toastService.show("Erro ao atualizar status", {
              classname: "bg-danger text-light",
            });
          },
          complete: () => {
            this.loading = false;
            window.location.reload();
          },
        });
    } else {
      this.statusConfigService
        .createStatusMessage(this.statusForm.value)
        .subscribe({
          next: () => {
            // this.toastService.show("Mensagem criado com sucesso", {
            //   classname: "bg-success text-light",
            // });
            this.activeModal.close();
          },
          error: () => {
            this.toastService.show("Erro ao criar status", {
              classname: "bg-danger text-light",
            });
          },
          complete: () => {
            this.loading = false;
            window.location.reload();
          },
        });
    }
  }
}